/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useEffect, useState } from "react";
import "./Underwriting.css";
import { useNavigate, useSearchParams, useParams } from "react-router-dom";
import lodash from "lodash";
import Moment from "moment";
// import { withSwal } from "react-sweetalert2";
// Axios
import {
  canModifyQuotation,
  isUnderwritingReferred,
  // getTotalPremium,
  getUserDataFromLocalStorage,
  processUnderwritingData,
} from "../core/utils";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
// Components
import Navbar from "../core/components/NavBar";
import UserContext from "../core/UserContext";
import PersonalApplications from "./cummulative-risk/cummulative-purpose-personal/personal-applications/PersonalApplications";
import CummulativePurpose from "./cummulative-risk/cummulative-purpose/CummulativePurpose";
import PersonalCover from "./cummulative-risk/cummulative-purpose-personal/personal-cover/PersonalCover";
import PersonalIncome from "./cummulative-risk/cummulative-purpose-personal/personal-income/PersonalIncome";
import PersonalDependents from "./cummulative-risk/cummulative-purpose-personal/personal-dependents/PersonalDependents";
import PersonalPolicyReason from "./cummulative-risk/cummulative-purpose-personal/personal-policy-reason/PersonalPolicyReason";
import PersonalSumAssured from "./cummulative-risk/cummulative-purpose-personal/personal-sum-assured/PersonalSumAssured";
import PersonalAssets from "./cummulative-risk/cummulative-purpose-personal/personal-assets/PersonalAssets";
import MortgageLoanPurpose from "./cummulative-risk/cummulative-mortageloan/mortgageloan-purpose/MortgageLoanPurpose";
// import SweetAlert2 from "react-sweetalert2";
import InheritanceTaxEstimated from "./cummulative-risk/cummulative-inheritancetax/inheritancetax-estimated/InheritanceTaxEstimated";
import InheritanceTaxLiability from "./cummulative-risk/cummulative-inheritancetax/inheritancetax-liability/InheritanceTaxLiability";
import InheritanceTaxLiabilityFall from "./cummulative-risk/cummulative-inheritancetax/inheritancetax-liabilityfall/InheritanceTaxLiabilityFall";
import InheritanceTaxNetWorth from "./cummulative-risk/cummulative-inheritancetax/inheritancetax-networth/InheritanceTaxNetWorth";
import InheritanceTaxOtherFactors from "./cummulative-risk/cummulative-inheritancetax/inheritancetax-other-factors/InheritanceTaxOtherFactors";
import InheritanceTaxRelief from "./cummulative-risk/cummulative-inheritancetax/inheritancetax-relief/InheritanceTaxRelief";

const FinancialUnderwriting = () => {
  const { userData, setUserData } = useContext(UserContext);
  const userDataStorage = getUserDataFromLocalStorage();
  const axiosPrivate = useAxiosPrivate(userDataStorage);
  // const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [nextLoading, setNextLoading] = useState(false);
  const [authorized, setAuthorized] = useState();
  const params = useParams();
  const [quotationId, setQuotationId] = useState();
  const [requestMode, setRequestMode] = useState("create");
  // const [underwritingForQuotation, setUnderwritingForQuotation] = useState();
  const [processedMainLifeData, setProcessedMainLifeData] = useState();
  const [underwritingData, setUnderwritingData] = useState();
  const [mainLifeUnderwritingCreated, setMainLifeUnderwritingCreated] =
    useState(false);
  const [updatingQuotationStatus, setUpdatingQuotationStatus] = useState(false);
  const [processedJointLifeData, setProcessedJointLifeData] = useState();

  const inheritanceTaxPages = [
    "inheritancetax-estimated",
    "inheritancetax-liability",
    "inheritancetax-liability-fall",
    "inheritancetax-networth",
    "inheritancetax-other-factors",
    "inheritancetax-relief",
  ];
  const personalPages = [
    "personal-applications",
    "personal-cover",
    "personal-income",
    "personal-dependents",
    "personal-policy-reason",
    "personal-sum-assured",
    "personal-assets",
  ];
  const mortgagePages = ["mortgageloan-purpose"];

  const [jointLifeUnderwritingCreated, setJointLifeUnderwritingCreated] =
    useState(false);
  const [finalVerdict, setFinalVerdict] = useState();
  const [error, setError] = useState();
  const [quotation, setQuotation] = useState();
  const [consent, setConsent] = useState(false);
  const [state, setState] = useState({
    life: params.life,
    joinLoan: null,
    isPersonalProtection: false,
    isMortgageLoanProtection: false,
    isInheritanceTaxCover: false,
    other_applications_joint_details: null,
    other_applications_joint_life: null,
    other_applications_main_details: null,
    other_applications_main_life: null,
    personal_cover_main_life: null,
    personal_cover_main_life_reason: null,
    personal_cover_joint_life: null,
    personal_cover_joint_life_reason: null,
    occupation_income_main_life: null,
    occupation_income_joint_life: null,
    investments_income_main_life: null,
    investments_income_joint_life: null,
    other_source_income_main_life: null,
    other_source_income_joint_life: null,
    dependents_main_life: null,
    dependents_joint_life: null,
    policy_reason_main_life: null,
    sum_assured_main_life: null,
    sum_assured_joint_life: null,
    assets_property_main_life: null,
    assets_investments_main_life: null,
    assets_entities_main_life: null,
    assets_property_joint_life: null,
    assets_investments_joint_life: null,
    assets_entities_joint_life: null,
    assets_others_main_life: null,
    assets_others_joint_life: null,
    liability_mortgage_main_life: null,
    liability_loan_main_life: null,
    liability_others_main_life: null,
    liability_mortgage_joint_life: null,
    liability_loan_joint_life: null,
    liability_others_joint_life: null,
    mortgageloan_purpose_main_life: null,
    mortgageloan_purpose_joint_life: null,
    inheritancetax_estimated_liability_main_life: null,
    inheritancetax_estimated_liability_joint_life: null,
    inheritancetax_liability_calculated_main_life: null,
    inheritancetax_liability_calculated_joint_life: null,
    inheritancetax_liability_fall_main_life: null,
    inheritancetax_liability_fall_joint_life: null,
    inheritancetax_net_worth_main_life: null,
    inheritancetax_net_worth_joint_life: null,
    inheritancetax_otherfactors_main_life: null,
    inheritancetax_otherfactors_joint_life: null,
    inheritancetax_relief_main_life: null,
    inheritancetax_relief_joint_life: null,
  });

  const [pages, setPages] = useState(["cummulative-purpose"]);

  useEffect(() => {
    // console.log({state});
    updatePages(
      state.isPersonalProtection,
      state.isMortgageLoanProtection,
      state.isInheritanceTaxCover
    );
    // console.log(pages);
  }, [state]);

  useEffect(() => {
    loadPageData();
  }, []);

  const loadPageData = async () => {
    await setQuotationId(params.quotationId);
    await getQuotationDetails();
    await getUnderwritingData();
  };
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  // const [terminalMessage, setTerminalMessage] = useState();

  const updateQuotationStatus = async (payload) => {
    setUpdatingQuotationStatus(true);
    const url =
      process.env.REACT_APP_API_URL +
      `/quotation/worker/status-update/${quotationId}`;

    try {
      payload = { ...payload, userId: quotation?.user?.id };
      const { data } = await axiosPrivate.patch(url, payload);

      setUpdatingQuotationStatus(false);

      if (!data.success) {
        console.log(
          data.message
            ? data.message
            : "Quotation update was unsuccessful, please try again"
        );
      } else {
        // navigate(`/review/${quotation.id}`);
      }
    } catch (error) {
      setUpdatingQuotationStatus(false);
      console.log(error);
    }
  };

  const declarationsInvalidForLife = async (id) => {
    const url = process.env.REACT_APP_API_URL + `/user/declarations/${id}`;

    try {
      const response = await axiosPrivate.get(url);

      console.log(response.data.data.Declarations);
      const declarations = response.data.data.Declarations;
      for (let i = 0; i < declarations.length; i++) {
        if (declarations[i].UserDeclaration.consent) {
          return true;
          // eslint-disable-next-line no-unreachable
          break;
        }
      }
      return false;
    } catch (err) {
      console.log(err);
      return true;
    }
  };

  const getEightMillionRuleBoolean = async (
    amount,
    userId,
    userJointId = null
  ) => {
    const url = process.env.REACT_APP_API_URL + `/quotation/check/exceeded`;

    try {
      const response = await axiosPrivate.post(url, {
        amount,
        userId,
        quotationId: parseInt(quotationId),
        userJointId,
      });
      return response.data.success ? response.data.data : false;
    } catch (err) {
      console.log(err);
      return false;
    }
  };

  const getDeclarationsStatusForUser = async (userId, policyId) => {
    const url = process.env.REACT_APP_API_URL + `/user/declarations/${userId}`;

    try {
      const response = await axiosPrivate.get(url);

      const declarationsForQuotation = response.data.data.filter(
        (item) => item.quotationId === quotationId
      );

      if (declarationsForQuotation.length === 0) {
        return false;
      }

      for (let i = 0; i < declarationsForQuotation.length; i++) {
        const item = declarationsForQuotation[i];
        if (item.consent) {
          return false;
        }
      }

      return true;
    } catch (err) {
      console.log(err);
      return false;
    }
  };

  const proceed = async () => {
    await updateQuotationStatus({ status: "kyc" });
    navigate(`/client-kyc/${quotation?.user?.id}/${quotation?.id}/main`);

    // if (quotation?.quotationFormData?.join_loan) {
    // const userDeclarationStatus = await getDeclarationsStatusForUser(
    //   quotation?.user?.id
    // );

    // const userJointDeclarationStatus = await getDeclarationsStatusForUser(
    //   quotation?.userJoint?.id
    // );

    // if (
    //   (!quotation?.user?.kycVerification || !userDeclarationStatus) &&
    //   !(
    //     quotation?.user?.declarationsManuallyVerified &&
    //     quotation?.user?.shuftiManuallyVerified
    //   )
    // ) {
    // await updateQuotationStatus({ status: "kyc" });
    // navigate(`/client-kyc/${quotation?.user?.id}/${quotation?.id}/main`);
    // } else if (
    //   (!quotation?.userJoint?.kycVerification ||
    //     !userJointDeclarationStatus) &&
    //   !(
    //     quotation?.userJoint?.declarationsManuallyVerified &&
    //     quotation?.userJoint?.shuftiManuallyVerified
    //   )
    // ) {
    //   await updateQuotationStatus({ status: "kyc" });
    //   navigate(
    //     `/client-kyc/${quotation?.userJoint?.id}/${quotation?.id}/joint`
    //   );
    // } else {
    //   await updateQuotationStatus({ status: "review" });
    //   navigate(`/review/${quotation.id}`);
    // }
    //TODO: PEP check for joint loan
    //   } else if (!quotation?.quotationFormData?.join_loan) {
    //     const userDeclarationStatus = await getDeclarationsStatusForUser(
    //       quotation?.user?.id
    //     );

    //     if (
    //       (!quotation?.user?.kycVerification || !userDeclarationStatus) &&
    //       !(
    //         quotation?.user?.declarationsManuallyVerified &&
    //         quotation?.user?.shuftiManuallyVerified
    //       )
    //     ) {
    //       await updateQuotationStatus({ status: "kyc" });
    //       navigate(`/client-kyc/${quotation?.user?.id}/${quotation?.id}/main`);
    //     } else {
    //       await updateQuotationStatus({ status: "review" });
    //       navigate(`/review/${quotation.id}`);
    //     }
    //   } else {
    //     await updateQuotationStatus({ status: "review" });
    //     navigate(`/review/${quotation.id}`);
    //   }
  };

  const patchUnderwriting = async (isfinal = false) => {
    const url =
      process.env.REACT_APP_API_URL + `/underwriting/finance/${quotationId}`;
    const getUnderwritingUrl =
      process.env.REACT_APP_API_URL + `/underwriting/${quotationId}`;

    const currentQuotationDetails = await axiosPrivate.get(getUnderwritingUrl);

    console.log(currentQuotationDetails.data);
    currentQuotationDetails.data.data.underwritingJointData = JSON.parse(
      currentQuotationDetails.data.data.underwritingJointData,
      10
    );

    const payload = {
      ...currentQuotationDetails.data.data,
      underwritingData: { data: processUnderwritingData(state) },
    };

    setNextLoading(true);
    try {
      const response = await axiosPrivate.patch(url, payload);

      setNextLoading(false);
      // setMainLifeUnderwritingCreated(true);
      setProcessedMainLifeData(processUnderwritingData(state));

      navigate(`/underwriting-summary/${quotation?.user?.id}/${quotationId}`);
      setLoading(false);
      console.log(response.data);
    } catch (err) {
      setLoading(false);

      if (err?.response?.data) {
        setError(
          err?.response?.data
            ? err?.response?.data?.message.split(".")[0]
            : "Underwriting was unsuccessful, please try again"
        );
      } else {
        setError("Underwriting was unsuccessful, please try again");
      }
      console.log(err);
    }
  };

  const finalSubmit = async () => {
    setNextLoading(true);

    if (params.life === "main-life") {
      const url =
        process.env.REACT_APP_API_URL + `/underwriting/finance/${quotationId}`;
      const payload = {
        underwritingFinanceMainData: {
          life: state.life,
          joinLoan: state.joinLoan,
          isPersonalProtection: state.isPersonalProtection,
          isMortgageLoanProtection: state.isMortgageLoanProtection,
          isInheritanceTaxCover: state.isInheritanceTaxCover,
          other_applications_main_details:
            state.other_applications_main_details,
          other_applications_main_life: state.other_applications_main_life,
          personal_cover_main_life: state.personal_cover_main_life,
          personal_cover_main_life_reason:
            state.personal_cover_main_life_reason,
          occupation_income_main_life: state.occupation_income_main_life,
          investments_income_main_life: state.investments_income_main_life,
          other_source_income_main_life: state.other_source_income_main_life,
          dependents_main_life: state.dependents_main_life,
          policy_reason_main_life: state.policy_reason_main_life,
          sum_assured_main_life: state.sum_assured_main_life,
          assets_property_main_life: state.assets_property_main_life,
          assets_investments_main_life: state.assets_investments_main_life,
          assets_entities_main_life: state.assets_entities_main_life,
          assets_others_main_life: state.assets_others_main_life,
          liability_mortgage_main_life: state.liability_mortgage_main_life,
          liability_loan_main_life: state.liability_loan_main_life,
          liability_others_main_life: state.liability_others_main_life,
          mortgageloan_purpose_main_life: state.mortgageloan_purpose_main_life,
          inheritancetax_estimated_liability_main_life:
            state.inheritancetax_estimated_liability_main_life,
          inheritancetax_liability_calculated_main_life:
            state.inheritancetax_liability_calculated_main_life,
          inheritancetax_liability_fall_main_life:
            state.inheritancetax_liability_fall_main_life,
          inheritancetax_net_worth_main_life:
            state.inheritancetax_net_worth_main_life,
          inheritancetax_otherfactors_main_life:
            state.inheritancetax_otherfactors_main_life,
          inheritancetax_relief_main_life:
            state.inheritancetax_relief_main_life,
        },
      };

      try {
        const response = await axiosPrivate.patch(url, payload);
        setNextLoading(false);
        if (response.data.success) {
          console.log(response.data);
          if (quotation.joinLoan === true) {
            return (window.location.href = `${process.env.REACT_APP_BASENAME}/financial-underwriting/${quotationId}/joint-life`);
          } else {
            return (window.location.href = `${process.env.REACT_APP_BASENAME}/underwriting-summary/${quotation?.user?.id}/${quotationId}`);
          }
        } else {
          setError("Underwriting was unsuccessful, please try again");
        }
      } catch (err) {
        //Handing Form Errors
        setNextLoading(false);
        setError(
          (err && err.response.message) ||
            "Underwriting was unsuccessful, please try again"
        );
      }
    } else if (params.life === "joint-life") {
      const url =
        process.env.REACT_APP_API_URL + `/underwriting/finance/${quotationId}`;
      const payload = {
        underwritingFinanceJointData: {
          life: state.life,
          joinLoan: state.joinLoan,
          isPersonalProtection: state.isPersonalProtection,
          isMortgageLoanProtection: state.isMortgageLoanProtection,
          isInheritanceTaxCover: state.isInheritanceTaxCover,
          other_applications_joint_details:
            state.other_applications_joint_details,
          other_applications_joint_life: state.other_applications_joint_life,
          personal_cover_joint_life: state.personal_cover_joint_life,
          personal_cover_joint_life_reason:
            state.personal_cover_joint_life_reason,
          occupation_income_joint_life: state.occupation_income_joint_life,
          investments_income_joint_life: state.investments_income_joint_life,
          other_source_income_joint_life: state.other_source_income_joint_life,
          dependents_joint_life: state.dependents_joint_life,
          sum_assured_joint_life: state.sum_assured_joint_life,
          assets_property_joint_life: state.assets_property_joint_life,
          assets_investments_joint_life: state.assets_investments_joint_life,
          assets_entities_joint_life: state.assets_entities_joint_life,
          assets_others_joint_life: state.assets_others_joint_life,
          liability_mortgage_joint_life: state.liability_mortgage_joint_life,
          liability_loan_joint_life: state.liability_loan_joint_life,
          liability_others_joint_life: state.liability_others_joint_life,
          mortgageloan_purpose_joint_life:
            state.mortgageloan_purpose_joint_life,
          policy_reason_joint_life: state.policy_reason_joint_life,
          inheritancetax_estimated_liability_joint_life:
            state.inheritancetax_estimated_liability_joint_life,
          inheritancetax_liability_calculated_joint_life:
            state.inheritancetax_liability_calculated_joint_life,
          inheritancetax_liability_fall_joint_life:
            state.inheritancetax_liability_fall_joint_life,
          inheritancetax_net_worth_joint_life:
            state.inheritancetax_net_worth_joint_life,
          inheritancetax_otherfactors_joint_life:
            state.inheritancetax_otherfactors_joint_life,
          inheritancetax_relief_joint_life:
            state.inheritancetax_relief_joint_life,
        },
      };
      try {
        const response = await axiosPrivate.patch(url, payload);
        setNextLoading(false);
        if (response.data.success) {
          console.log(response.data);
          return (window.location.href = `${process.env.REACT_APP_BASENAME}/underwriting-summary/${quotation?.user?.id}/${quotationId}`);
        } else {
          setError("Underwriting was unsuccessful, please try again");
        }
      } catch (err) {
        //Handing Form Errors
        setNextLoading(false);
        setError("Underwriting was unsuccessful, please try again");
        console.log(err);
      }
    }

    // console.log(state);
    // processUnderwritingData(state);
  };

  const sendEmailWithAttachment = async () => {
    setNextLoading(true);
    const url =
      process.env.REACT_APP_API_URL +
      `/utils/send-email/attachment/proposal-form/${quotationId}`;

    let message = `<p>Dear ILA Underwriter</p><p>You have received a referred underwriting request on client proposal with the details;</p><p><strong>Quotation ID : ${
      quotation.id
    }</strong></p><p><strong>Temporal Policy Number: ${
      quotation.temporaryId
    }</strong></p><p><strong>Name:${
      quotation?.joinLoan
        ? quotation?.user?.name + " | " + quotation?.userJoint?.name
        : quotation?.user?.name
    }</strong></p><p><strong>Date: ${new Moment(quotation.createdAt).format(
      "DD/MM/YYYY"
    )}</strong></p><p>The proposal form is attached for your review and attention.</p><p>Kind Regards</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>`;
    const payload = {
      emails: ["underwriting@ila.mu"],
      subjectTitle: "Referred Quotation",
      messageHtml: message,
    };

    try {
      const response = await axiosPrivate.post(url, payload);
      setNextLoading(false);

      if (response.data.success === true) {
        console.log("successfully sent email");
      }
    } catch (error) {
      setNextLoading(false);
      console.log(error);
    }
  };
  const getQuotationDetails = async () => {
    const id = params.quotationId;
    const url = process.env.REACT_APP_API_URL + `/quotation/${id}`;
    const userData = getUserDataFromLocalStorage();
    const userId = userData?.data?.id;

    try {
      const response = await axiosPrivate.get(url);
      if (response.data.success === true) {
        const _quotation = response.data.data;
        setState({ ...state, joinLoan: _quotation?.joinLoan });
        console.log({ _quotation });
        _quotation.quotationFormData = JSON.parse(_quotation.quotationFormData);
        const totalPremium = _quotation.premiumAmount;
        _quotation.totalPremium = totalPremium;
        if (!canModifyQuotation(_quotation, userId)) {
          setAuthorized(false);
          return;
        } else {
          setAuthorized(true);
        }
        setQuotation(_quotation);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const saveUnderwritingState = async () => {
    const url =
      process.env.REACT_APP_API_URL + `/underwriting/finance/${quotationId}`;
    setNextLoading(true);
    const getUnderwritingUrl =
      process.env.REACT_APP_API_URL + `/underwriting/${quotationId}`;

    const currentUnderwritingDetails = await axiosPrivate.get(
      getUnderwritingUrl
    );

    let payload;
    if (params.life === "main-life") {
      currentUnderwritingDetails.data.data.underwritingJointData = JSON.parse(
        currentUnderwritingDetails.data.data.underwritingJointData,
        10
      );

      payload = {
        ...currentUnderwritingDetails.data.data,
        underwritingData: { data: processUnderwritingData(state), step },
      };
    } else {
      currentUnderwritingDetails.data.data.underwritingData = JSON.parse(
        currentUnderwritingDetails.data.data.underwritingData,
        10
      );

      payload = {
        ...currentUnderwritingDetails.data.data,
        underwritingJointData: { data: processUnderwritingData(state), step },
      };
    }

    try {
      const response = await axiosPrivate.patch(url, payload);
      if (response.data.success) {
        setStep(step + 1);
      }
      setNextLoading(false);
      console.log(response.data);
    } catch (err) {
      setNextLoading(false);

      if (err?.response?.data) {
        setError(
          err?.response?.data
            ? err?.response?.data?.message.split(".")[0]
            : "Underwriting was unsuccessful, please try again"
        );
      } else {
        setError("Underwriting was unsuccessful, please try again");
      }
      console.log(err);
    }
  };

  const getUnderwritingData = async () => {
    const getUnderwritingUrl =
      process.env.REACT_APP_API_URL + `/underwriting/${params.quotationId}`;

    const currentUnderwritingDetails = await axiosPrivate.get(
      getUnderwritingUrl
    );

    if (currentUnderwritingDetails.data.success) {
      let data = null;
      if (params.life == "main-life") {
        data = JSON.parse(
          currentUnderwritingDetails.data.data.underwritingFinanceMainData
        );
      }
      if (params.life == "joint-life") {
        data = JSON.parse(
          currentUnderwritingDetails.data.data.underwritingFinanceJointData
        );
      }

      setUnderwritingData(data);
      setState({ ...state, ...data });
      if (!data) {
        setRequestMode("update");
      }
    }
  };

  const getUnderwritingDataValue = async (life, qtnId) => {
    const getUnderwritingUrl =
      process.env.REACT_APP_API_URL + `/underwriting/${qtnId}`;

    const currentUnderwritingDetails = await axiosPrivate.get(
      getUnderwritingUrl
    );

    if (currentUnderwritingDetails.data.success) {
      if (life === "main-life") {
        const fieldsFromGET = JSON.parse(
          currentUnderwritingDetails.data.data.underwritingData
        ).data.map((item) => {
          return { key: item.key, response: item.response };
        });
        let fieldsAsObject = {};
        fieldsFromGET.forEach((field) => {
          fieldsAsObject[field.key] = field.response;
        });

        return fieldsAsObject;
      } else if (life === "joint-life") {
        const fieldsFromGET = JSON.parse(
          currentUnderwritingDetails.data.data.underwritingJointData
        ).data.map((item) => {
          return { key: item.key, response: item.response };
        });
        let fieldsAsObject = {};
        fieldsFromGET.forEach((field) => {
          fieldsAsObject[field.key] = field.response;
        });
        return fieldsAsObject;
      }
    } else {
      return {};
    }
  };

  const createNewUnderwriting = async () => {
    setNextLoading(true);
    if (params.life === "main-life") {
      const url = process.env.REACT_APP_API_URL + `/underwriting`;
      const payload = {
        quotationId: parseInt(quotationId, 10),
        underwritingData: { data: processUnderwritingData(state), step },
        underwritingJointData: { data: [] },
      };
      try {
        const response = await axiosPrivate.post(url, payload);
        setNextLoading(false);
        if (response.data.success) {
          setRequestMode("update");
          setStep(step + 1);
        }
      } catch (err) {
        //Handing Form Errors

        setError(null);

        if (err?.response?.data) {
          setNextLoading(false);
          setError(
            err?.response?.data
              ? err?.response?.data?.message.split(".")[0]
              : "Could not save state"
          );
        } else {
          setNextLoading(false);
          setError("Could not save state");
        }
        console.log(err);
      }
    } else if (params.life === "joint-life") {
      const url =
        process.env.REACT_APP_API_URL + `/underwriting/${quotationId}`;
      const getUnderwritingUrl =
        process.env.REACT_APP_API_URL + `/underwriting/${quotationId}`;

      const currentUnderwriting = await axiosPrivate.get(getUnderwritingUrl);
      console.log(currentUnderwriting.data);
      currentUnderwriting.data.data.underwritingData = JSON.parse(
        currentUnderwriting.data.data.underwritingData,
        10
      );

      const payload = {
        ...currentUnderwriting.data.data,
        underwritingJointData: { data: processUnderwritingData(state), step },
      };

      try {
        const response = await axiosPrivate.patch(url, payload);

        if (response.data.success) {
          setRequestMode("update");
          setStep(step + 1);
        }

        setNextLoading(false);
        console.log(response.data);
      } catch (err) {
        setNextLoading(false);
        if (err?.response?.data) {
          setError(
            err?.response?.data
              ? err?.response?.data?.message.split(".")[0]
              : "Underwriting was unsuccessful, please try again"
          );
        } else {
          setError("Underwriting was unsuccessful, please try again");
        }
        console.log(err);
      }
    }
  };

  const updatePages = (personalProtection, mortgageLoan, inheritanceTax) => {
    let updatedPages = [...pages];

    if (state.isPersonalProtection === true) {
      if (!updatedPages.includes(personalPages[0])) {
        for (let i = 0; i < personalPages.length; i++) {
          let p = personalPages[i];
          updatedPages.push(p);
        }
      }
    } else {
      updatedPages = updatedPages.filter((p, index) => {
        return !personalPages.includes(p);
      });
    }
    if (state.isMortgageLoanProtection === true) {
      if (!updatedPages.includes(mortgagePages[0])) {
        updatedPages.push(...mortgagePages);
      }
    } else {
      updatedPages = updatedPages.filter((p, index) => {
        return !mortgagePages.includes(p);
      });
    }
    if (state.isInheritanceTaxCover === true) {
      if (!updatedPages.includes(inheritanceTaxPages[0])) {
        for (let i = 0; i < inheritanceTaxPages.length; i++) {
          let p = inheritanceTaxPages[i];
          updatedPages.push(p);
        }
      }
    } else {
      updatedPages = updatedPages.filter((p, index) => {
        return !inheritanceTaxPages.includes(p);
      });
    }

    setPages(updatedPages);
  };

  const onNext = () => {
    setError(null);
    updatePages(
      state.isPersonalProtection,
      state.isMortgageLoanProtection,
      state.isInheritanceTaxCover
    );
    const currentPage = pages[step - 1];

    let stepIndex = step - 1;
    if (stepIndex < pages.length) {
      console.log("state", state);
      updatePages();

      if (currentPage === "cummulative-purpose") {
        if (
          !(
            state.isPersonalProtection ||
            state.isMortgageLoanProtection ||
            state.isInheritanceTaxCover
          )
        ) {
          setError("Please select a purpose proposal");
          return;
        }
      }

      if (currentPage === "personal-applications") {
        if (state.life == "main-life") {
          if (state.other_applications_main_life == null) {
            setError("Please select an option");
            return;
          }
          if (
            state.other_applications_main_life == true &&
            !state.other_applications_main_details
          ) {
            setError("Please enter details");
            return;
          }
        }

        if (state.life == "joint-life") {
          if (state.other_applications_joint_life == null) {
            setError("Please select an option");
            return;
          }
          if (
            state.other_applications_joint_life == true &&
            !state.other_applications_joint_details
          ) {
            setError("Please enter details");
            return;
          }
        }
      }

      if (currentPage === "personal-cover") {
        if (state.life == "main-life") {
          if (!state.personal_cover_main_life) {
            setError("Please enter a cover amount");
            return;
          }
          let firstLifecoverAmt =
            parseFloat(
              state.personal_cover_main_life?.toString()?.replace("Rs ", "")
            ) ?? 0;
          if (firstLifecoverAmt > 0 && !state.personal_cover_main_life_reason) {
            setError("Please provide a reason");
            return;
          }
        }

        if (state.life == "joint-life") {
          if (!state.personal_cover_joint_life) {
            setError("Please enter a cover amount");
            return;
          }
          let secondLifecoverAmt =
            parseFloat(
              state.personal_cover_joint_life?.toString()?.replace("Rs ", "")
            ) ?? 0;
          if (
            secondLifecoverAmt > 0 &&
            !state.personal_cover_joint_life_reason
          ) {
            setError("Please provide a reason");
            return;
          }
        }
      }

      if (currentPage === "personal-income") {
        if (state.life == "main-life") {
          if (
            !state.occupation_income_main_life ||
            !state.investments_income_main_life
          ) {
            setError("Please provide details below");
            return;
          }
        }

        if (state.life == "joint-life") {
          if (
            !state.occupation_income_joint_life ||
            !state.investments_income_joint_life
          ) {
            setError("Please provide details below");
            return;
          }
        }
      }

      if (currentPage === "personal-dependents") {
        if (state.life == "main-life") {
          if (!state.dependents_main_life) {
            setError("Please provide details below");
            return;
          }
        }

        if (state.life == "joint-life") {
          if (!state.dependents_joint_life) {
            setError("Please provide details below");
            return;
          }
        }
      }

      if (currentPage === "personal-policy-reason") {
        if (state.life == "main-life") {
          if (!state.policy_reason_main_life) {
            setError("Please provide details below");
            return;
          }
        }
        if (state.life == "joint-life") {
          if (!state.policy_reason_joint_life) {
            setError("Please provide details below");
            return;
          }
        }
      }

      if (currentPage === "personal-sum-assured") {
        if (state.life == "main-life") {
          if (!state.sum_assured_main_life) {
            setError("Please provide details below");
            return;
          }
        }
        if (state.life == "joint-life") {
          if (!state.sum_assured_joint_life) {
            setError("Please provide details below");
            return;
          }
        }
      }

      if (currentPage === "personal-assets") {
        if (state.life == "main-life") {
          if (
            !(
              state.assets_property_main_life &&
              state.liability_mortgage_main_life &&
              state.assets_investments_main_life &&
              state.liability_loan_main_life &&
              state.assets_entities_main_life
            )
          ) {
            setError("Please provide details below");
            return;
          }
        }
        if (state.life == "joint-life") {
          if (
            !(
              state.assets_property_joint_life &&
              state.liability_mortgage_joint_life &&
              state.assets_investments_joint_life &&
              state.liability_loan_joint_life &&
              state.assets_entities_joint_life
            )
          ) {
            setError("Please provide details below");
            return;
          }
        }
      }

      if (currentPage === "mortgageloan-purpose") {
        if (state.life == "main-life") {
          if (!state.mortgageloan_purpose_main_life) {
            setError("Please provide details below");
            return;
          }
        }
        if (state.life == "joint-life") {
          if (!state.mortgageloan_purpose_joint_life) {
            setError("Please provide details below");
            return;
          }
        }
      }

      if (currentPage === "inheritancetax-estimated") {
        if (state.life == "main-life") {
          if (!state.inheritancetax_estimated_liability_main_life) {
            setError("Please provide details below");
            return;
          }
        }
        if (state.life == "joint-life") {
          if (!state.inheritancetax_estimated_liability_joint_life) {
            setError("Please provide details below");
            return;
          }
        }
      }

      if (currentPage === "inheritancetax-liability") {
        if (state.life == "main-life") {
          if (!state.inheritancetax_liability_calculated_main_life) {
            setError("Please provide details below");
            return;
          }
        }
        if (state.life == "joint-life") {
          if (!state.inheritancetax_liability_calculated_joint_life) {
            setError("Please provide details below");
            return;
          }
        }
      }

      if (currentPage === "inheritancetax-liability-fall") {
        if (state.life == "main-life") {
          if (!state.inheritancetax_liability_fall_main_life) {
            setError("Please provide details below");
            return;
          }
        }
        if (state.life == "joint-life") {
          if (!state.inheritancetax_liability_fall_joint_life) {
            setError("Please provide details below");
            return;
          }
        }
      }

      if (currentPage === "inheritancetax-networth") {
        if (state.life == "main-life") {
          if (!state.inheritancetax_net_worth_main_life) {
            setError("Please provide details below");
            return;
          }
        }
        if (state.life == "joint-life") {
          if (!state.inheritancetax_net_worth_joint_life) {
            setError("Please provide details below");
            return;
          }
        }
      }

      if (currentPage === "inheritancetax-other-factors") {
        if (state.life == "main-life") {
          if (!state.inheritancetax_otherfactors_main_life) {
            setError("Please provide details below");
            return;
          }
        }
        if (state.life == "joint-life") {
          if (!state.inheritancetax_otherfactors_joint_life) {
            setError("Please provide details below");
            return;
          }
        }
      }

      if (currentPage === "inheritancetax-relief") {
        if (state.life == "main-life") {
          if (!state.inheritancetax_relief_main_life) {
            setError("Please provide details below");
            return;
          }
        }
        if (state.life == "joint-life") {
          if (!state.inheritancetax_relief_joint_life) {
            setError("Please provide details below");
            return;
          }
        }
      }

      setNextLoading(true);
      if (stepIndex == pages.length - 1) {
        finalSubmit();
      } else {
        setTimeout(() => {
          setNextLoading(false);
          setStep(step + 1);
        }, 500);
      }
    } else {
      if (currentPage === "cummulative-purpose") {
        if (
          !(
            state.isPersonalProtection ||
            state.isMortgageLoanProtection ||
            state.isInheritanceTaxCover
          )
        ) {
          return setError("Please select a purpose proposal");
        }
      }
      finalSubmit();
    }
  };
  const onPrev = () => {
    if (step > 1) {
      if (pages[step - 1] === "reflex-one-conditions") {
        let updatedPages = pages;
        const deletedArr = updatedPages.splice(step - 1, 3);

        setPages(updatedPages);
        console.log(deletedArr);
      }
      if (pages[step - 1] === "reflex-four-conditions") {
        let updatedPages = pages;
        const deletedArr = updatedPages.splice(step - 1, 1);
        setPages(updatedPages);
        console.log(deletedArr);
      }
      setStep(step - 1);
    }
  };

  return (
    <>
      <Navbar
        name={
          userData
            ? `${userData?.data?.firstname} ${userData?.data?.lastname}`
            : ""
        }
      />
      {authorized && (
        <div className="container">
          <h4 className="mt-4 ila-grey-text">Financial Underwriting</h4>
          {quotation && (
            <>
              {params.life === "joint-life" ? (
                <div>
                  Questions to be answered by the joint life assured{" "}
                  <b>{quotation?.userJoint?.name}</b>
                </div>
              ) : (
                <div>
                  Questions to be answered by the main life assured{" "}
                  <b>{quotation?.user?.name}</b>
                </div>
              )}
            </>
          )}

          {/* <div class="my-3">
                Enter parameters to generate quotation
            </div> */}
          {((params.life === "main-life" && !mainLifeUnderwritingCreated) ||
            (params.life === "joint-life" &&
              !jointLifeUnderwritingCreated)) && (
            <div
              class="card p-5"
              style={{ background: "#C1C1C115", border: "none", marginTop: 30 }}
            >
              <div class="card-body">
                <h6 className="fw-bold w-100">
                  <div class="progress mb-5">
                    <div
                      class="progress-bar progress-bar-striped bg-success"
                      role="progressbar"
                      aria-label="Success striped example"
                      style={{ width: `${(step / pages.length) * 100}%` }}
                      aria-valuenow={step}
                      aria-valuemin="0"
                      aria-valuemax={pages.length}
                    ></div>
                  </div>
                </h6>
                <div className="alert alert-info my-4">
                  <i className="fa fa-info-circle me-3"></i>
                  Please answer all questions correctly and truthfully. Failure
                  to disclose any facts may lead to the insurance contract being
                  null and void and any future claim may as well be voided.
                </div>
                {error && (
                  <div className="alert alert-danger my-4">
                    <i className="fa fa-warning me-3"></i>
                    {error}
                  </div>
                )}

                {pages[step - 1] === "cummulative-purpose" && (
                  <CummulativePurpose
                    number={step}
                    state={state}
                    setState={setState}
                    updatePages={updatePages}
                  />
                )}

                {pages[step - 1] === "personal-applications" && (
                  <PersonalApplications
                    number={step}
                    state={state}
                    setState={setState}
                  />
                )}

                {pages[step - 1] === "personal-cover" && (
                  <PersonalCover
                    number={step}
                    state={state}
                    setState={setState}
                  />
                )}

                {pages[step - 1] === "personal-income" && (
                  <PersonalIncome
                    number={step}
                    state={state}
                    setState={setState}
                  />
                )}

                {pages[step - 1] === "personal-dependents" && (
                  <PersonalDependents
                    number={step}
                    state={state}
                    setState={setState}
                  />
                )}

                {pages[step - 1] === "personal-policy-reason" && (
                  <PersonalPolicyReason
                    number={step}
                    state={state}
                    setState={setState}
                  />
                )}

                {pages[step - 1] === "personal-sum-assured" && (
                  <PersonalSumAssured
                    number={step}
                    state={state}
                    setState={setState}
                  />
                )}

                {pages[step - 1] === "personal-assets" && (
                  <PersonalAssets
                    number={step}
                    state={state}
                    setState={setState}
                  />
                )}

                {pages[step - 1] === "mortgageloan-purpose" && (
                  <MortgageLoanPurpose
                    number={step}
                    state={state}
                    setState={setState}
                  />
                )}

                {pages[step - 1] === "inheritancetax-estimated" && (
                  <InheritanceTaxEstimated
                    number={step}
                    state={state}
                    setState={setState}
                  />
                )}

                {pages[step - 1] === "inheritancetax-liability" && (
                  <InheritanceTaxLiability
                    number={step}
                    state={state}
                    setState={setState}
                  />
                )}

                {pages[step - 1] === "inheritancetax-liability-fall" && (
                  <InheritanceTaxLiabilityFall
                    number={step}
                    state={state}
                    setState={setState}
                  />
                )}

                {pages[step - 1] === "inheritancetax-networth" && (
                  <InheritanceTaxNetWorth
                    number={step}
                    state={state}
                    setState={setState}
                  />
                )}

                {pages[step - 1] === "inheritancetax-other-factors" && (
                  <InheritanceTaxOtherFactors
                    number={step}
                    state={state}
                    setState={setState}
                  />
                )}
                {pages[step - 1] === "inheritancetax-relief" && (
                  <InheritanceTaxRelief
                    number={step}
                    state={state}
                    setState={setState}
                  />
                )}
                <div className="d-flex justify-content-between">
                  <a onClick={onPrev} className="btn ila-accent-btn">
                    <i className="fa fa-arrow-left me-2"></i>Prev
                  </a>
                  <a
                    onClick={onNext}
                    className="btn ila-accent-btn"
                    disabled={loading || nextLoading}
                  >
                    {loading ||
                      (nextLoading && (
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      ))}
                    {step === pages.length - 1 && "Next"}
                    {step === pages.length && "Complete"}
                    {step < pages.length - 1 && "Next"}

                    <i className="fa fa-arrow-right ms-2"></i>
                  </a>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {authorized === undefined && (
        <div>
          <div className="text-center">
            <span className="spinner-border  mt-5"></span>
          </div>
          <div className="text-center">Please wait ...</div>
        </div>
      )}
      {authorized === false && (
        <div className="container">
          {/* <h1 className="text-center">
            You are Unauthorized to modify this quotation
          </h1> */}

          <div
            style={{ marginTop: 50 }}
            class="alert alert-danger"
            role="alert"
          >
            You are Unauthorized to modify this quotation
          </div>
        </div>
      )}
    </>
  );
};

export default FinancialUnderwriting;
